import { Card, Col, Flex, Row } from 'antd'
import dayjs from 'dayjs'

import {
  Gender,
  GetPersonByIdnpResponse,
  TranslationDto
} from 'src/api/requests'
import { Text } from 'src/components'
import { dayMonthYearFormatWithDot } from 'src/libs'
import { useLocales } from 'src/locales'

type Props = {
  person?: GetPersonByIdnpResponse
}

export const SidaPatientIdentificationCard = ({ person }: Props) => {
  const { t, currentLang } = useLocales()

  const address = person?.currentAddress?.cuatmLocality
    ? [
        person?.currentAddress?.cuatmLocality?.translation?.[
          currentLang?.value as keyof TranslationDto
        ],
        person?.currentAddress?.street,
        person?.currentAddress?.streetNumber,
        person?.currentAddress?.apartmentNumber
      ]
        .filter(Boolean)
        .join(', ')
    : '-'

  const genderLabel =
    person?.gender === Gender.MALE
      ? t('sida_notification.male')
      : person?.gender === Gender.FEMALE
        ? t('sida_notification.female')
        : '-'

  return (
    <Card title={t('sida_notification.patient_identification')}>
      <Row gutter={[24, 24]}>
        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.idnp')}</Text>
            <Text weight={400}>{person?.idnp || '-'}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.full_name')}</Text>
            <Text weight={400}>
              {person?.firstName && person?.lastName
                ? `${person.lastName} ${person.firstName}`
                : '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.epidemiology_number')}</Text>
            <Text weight={400}>{person?.simeCode || '-'}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.birth_date')}</Text>
            <Text weight={400}>
              {person?.birthDate
                ? dayjs(person.birthDate).format(dayMonthYearFormatWithDot)
                : '-'}
            </Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.gender')}</Text>
            <Text weight={400}>{genderLabel}</Text>
          </Flex>
        </Col>

        <Col span={8}>
          <Flex vertical gap={4}>
            <Text>{t('sida_notification.current_address')}</Text>
            <Text weight={400}>{address}</Text>
          </Flex>
        </Col>
      </Row>
    </Card>
  )
}
